import { FC } from 'react';
import { Company } from '../../models/company.model';
import LogoSetting from '../setting/common/LogoSetting';
import blankCompany from '../../public/blank-company.png';
import Heading from '../chat/Heading';
import {
  StyledNoteText,
  StyledSampleDisplayContent,
  StyledSampleDisplayWrapper,
  StyledStepContent
} from './Styled';
import Image from 'next/image';
import Input from '../chat/Input';

const WalkthroughCompany: FC<{
  company?: Company;
  setAvatar: (_?: Blob) => void;
}> = ({ company, setAvatar }) => {
  return (
    <>
      <StyledStepContent>
        <Heading level={5} tag="h2" color="gray" mb="1.25rem">
          一般向表示用商号
        </Heading>
        <Input
          className="company-name"
          disabled
          value={company?.name || ''}
          onChange={() => {}}
          showClear={false}
        />
        <StyledNoteText>
          <p>※アットホームに登録されている一般向表示用商号が表示されます。</p>
        </StyledNoteText>
      </StyledStepContent>
      <StyledStepContent>
        <StyledSampleDisplayWrapper>
          <LogoSetting
            url={`${process.env.NEXT_PUBLIC_DOMAIN}/${company?.logo}`}
            fallback={blankCompany}
            onChange={(value) => setAvatar(value)}
            displayLarge
            showResetLink={false}
          />
          <StyledSampleDisplayContent>
            <Image
              className="sample-display-image"
              alt="メッセージ画面"
              src={blankCompany}
              width={120}
              height={120}
            />
            <p>
              未設定の場合は
              <br />
              こちらのアイコンになります
            </p>
          </StyledSampleDisplayContent>
        </StyledSampleDisplayWrapper>
      </StyledStepContent>
    </>
  );
};

export default WalkthroughCompany;
